module.exports = __webpack_public_path__ + "static/media/kidsartkids_02_C.73fcc156.png";